import React from "react";
import "./VisionIgnite.css";

const VisionIgnite = () => {
  return (
    <main className="vision-page">

      {/* HERO */}
      <section className="vision-section">
        <div className="vision-container vision-hero">

          <div className="vision-left">
            <div className="vision-badge">
              FYP — VISION IGNITE • <span>MEMBERSHIP</span>
            </div>

            <h1 className="vision-title">
              Reduce Your Dependence on Glasses.
            </h1>

            <p className="vision-subtitle">
              Vision Ignite is a guided eye-health membership for people who
              want to improve visual habits, reduce screen strain, and work
              toward clearer natural vision through daily practice.
            </p>

            <div className="vision-buttons">
              <a href="https://learn.forgeyourpeak.in/web/checkout/69e059ceca745f9ed6895c9f" className="vision-btn-primary">
                Join Vision Ignite for ₹8,999
              </a>

              <a href="#included" className="vision-btn-secondary">
                See What's Included
              </a>
            </div>

            <p className="vision-footnote">
              Daily routines • Monthly tracking • Community support • Built for
              regular people
            </p>
          </div>

          <div className="vision-right">
            <img
                src="/FYP-Visionignite/VisionIgnite.png"
                alt="Vision Ignite"
            />

            <div className="vision-overlay-card">
                <h3>Train Your Eyes Daily</h3>

                <p>
                Relaxation, focus flexibility, distance viewing,
                and visual acuity tracking.
                </p>
            </div>
            </div>

        </div>
      </section>

      {/* 5 PILLARS */}

      <section className="vision-section">
        <div className="vision-container vision-card">

          <h2 className="vision-heading">
            5 Pillars of Vision Ignite
          </h2>

          <p className="vision-description">
            Each pillar builds healthier visual function and better lifestyle
            support for your eyes.
          </p>

          <div className="vision-pillars">

            <div className="vision-pillar">
              <h4>Eye Relaxation</h4>
              <p>
                Release strain through palming, breath, and nervous-system
                calming.
              </p>
            </div>

            <div className="vision-pillar">
              <h4>Focus Flexibility</h4>
              <p>
                Train near-far shifting and reduce stiffness from screen-heavy
                habits.
              </p>
            </div>

            <div className="vision-pillar">
              <h4>Distance Vision</h4>
              <p>
                Rebuild the habit of looking far, exploring space, and using
                natural light.
              </p>
            </div>

            <div className="vision-pillar">
              <h4>Visual Awareness</h4>
              <p>
                Improve peripheral awareness, eye movement quality, and
                attention.
              </p>
            </div>

            <div className="vision-pillar">
              <h4>Recovery Habits</h4>
              <p>
                Sleep, screen breaks, sunlight, and simple routines that
                protect progress.
              </p>
            </div>

          </div>

        </div>
      </section>
      <section className="vision-section" id="included">
  <div className="vision-container vision-card">
    <h2 className="vision-heading">What's Included</h2>

    <p className="vision-description">
      A simple, structured stack: foundation → daily routines →
      monthly tracking → community.
    </p>

    <div className="vision-included-grid">

      <div className="vision-inc-card">
        <span className="vision-num">1</span>
        <div>
          <h4>Eye Health Reset Core</h4>
          <p>
            Understand how vision works, why strain builds,
            and how to begin safely.
          </p>
        </div>
      </div>

      <div className="vision-inc-card">
        <span className="vision-num">2</span>
        <div>
          <h4>Daily Vision Rituals</h4>
          <p>
            Short guided protocols for palming, sunning,
            distance viewing, and focus flexibility.
          </p>
        </div>
      </div>

      <div className="vision-inc-card">
        <span className="vision-num">3</span>
        <div>
          <h4>Visual Acuity Tracking</h4>
          <p>
            Measure your baseline and track improvements.
          </p>
        </div>
      </div>

      <div className="vision-inc-card">
        <span className="vision-num">4</span>
        <div>
          <h4>Monthly Challenges</h4>
          <p>
            Stay consistent with themed practice sprints.
          </p>
        </div>
      </div>

      <div className="vision-inc-card">
        <span className="vision-num">5</span>
        <div>
          <h4>Community Access</h4>
          <p>
            Share progress and stay accountable.
          </p>
        </div>
      </div>

      <div className="vision-inc-card">
        <span className="vision-num">6</span>
        <div>
          <h4>Upgrade Path</h4>
          <p>
            Move into deeper guidance and review.
          </p>
        </div>
        </div>

        </div>
        </div>
    </section>
     <section className="vision-section">
  <div className="vision-container vision-card">

    <h2 className="vision-heading">Who Is This For?</h2>

    <p className="vision-description">
      Designed for everyday people who want a structured
      path toward healthier eyesight.
    </p>

    <div className="vision-who-grid">

      <div className="vision-pillar">
        <h4>Students</h4>
        <p>
          Build better screen habits and protect visual
          attention during study years.
        </p>
      </div>

      <div className="vision-pillar">
        <h4>Working Professionals</h4>
        <p>
          Reduce screen strain and rebuild distance-vision
          habits after long workdays.
        </p>
      </div>

      <div className="vision-pillar">
        <h4>Parents & Families</h4>
        <p>
          Create simple visual-health routines that the
          whole family can follow.
        </p>
      </div>

    </div>

  </div>
</section>
<section className="vision-section" id="pricing">
  <div className="vision-container vision-card">

    <h2 className="vision-heading">
      Vision Ignite Membership
    </h2>

    <p className="vision-description">
      Start with the complete Vision Ignite system.
    </p>

    <div className="vision-price-card">

      <h3>Vision Ignite</h3>

      <div className="vision-price">
        ₹8,999
      </div>

      <p className="vision-price-note">
        One-Time Payment
      </p>

      <ul>
        <li>✓ Eye Health Reset Foundation</li>
        <li>✓ Daily Vision Training Library</li>
        <li>✓ Monthly Practice Challenges</li>
        <li>✓ Visual Acuity Tracking Guidance</li>
        <li>✓ Community Support</li>
      </ul>

      <a
        href="https://learn.forgeyourpeak.in/web/checkout/69e059ceca745f9ed6895c9f"
        className="vision-btn-primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        Join Vision Ignite
      </a>

    </div>

  </div>
</section>
      {/* IMPORTANT NOTE */}

<section className="vision-section">
  <div className="vision-container vision-card">

    <h2 className="vision-heading">
      Important Note
    </h2>

    <p
      className="vision-description"
      style={{
        maxWidth: "900px",
        margin: "20px auto"
      }}
    >
      Vision Ignite is an educational and training membership.
      It does not replace medical diagnosis, eye examination,
      or treatment from a qualified eye-care professional.

      Results vary based on age, prescription, habits,
      consistency, and individual visual condition.
    </p>

  </div>
</section>

{/* FAQ */}

<section className="vision-section">
  <div className="vision-container vision-card">

    <h2 className="vision-heading">
      FAQ
    </h2>

    <div className="vision-faq">

      <div className="vision-faq-item">
        <h4>
          Will this remove my glasses completely?
        </h4>

        <p>
          The goal is to reduce dependence where possible by
          improving visual habits and function. We avoid fake
          guarantees because every eye is different.
        </p>
      </div>

      <div className="vision-faq-item">
        <h4>
          How much time do I need daily?
        </h4>

        <p>
          Most routines are designed for 10–15 minutes per day,
          with extra lifestyle habits through the day.
        </p>
      </div>

      <div className="vision-faq-item">
        <h4>
          Is this only for athletes?
        </h4>

        <p>
          No. Vision Ignite is for anyone who wants healthier
          eyesight habits and reduced screen-related strain.
        </p>
      </div>

    </div>

  </div>
</section>

{/* FINAL CTA */}

<section className="vision-section">
  <div className="vision-container vision-final-cta">

    <h2>
      Start Your Natural Vision Journey
    </h2>

    <p>
      Build the daily habits, measurements, and routines
      that support clearer, calmer, healthier vision.
    </p>

    <a
      href="https://learn.forgeyourpeak.in/web/checkout/69e059ceca745f9ed6895c9f"
      className="vision-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Join Vision Ignite for ₹8,999
    </a>

  </div>
</section>

    </main>
  );
};

export default VisionIgnite;